/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputGeoPlaceNearest
 */
export interface OutputGeoPlaceNearest {
    /**
     * 
     * @type {number}
     * @memberof OutputGeoPlaceNearest
     */
    distanceM?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoPlaceNearest
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputGeoPlaceNearest
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoPlaceNearest
     */
    lat?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoPlaceNearest
     */
    lng?: number;
}

/**
 * Check if a given object implements the OutputGeoPlaceNearest interface.
 */
export function instanceOfOutputGeoPlaceNearest(value: object): boolean {
    return true;
}

export function OutputGeoPlaceNearestFromJSON(json: any): OutputGeoPlaceNearest {
    return OutputGeoPlaceNearestFromJSONTyped(json, false);
}

export function OutputGeoPlaceNearestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputGeoPlaceNearest {
    if (json == null) {
        return json;
    }
    return {
        
        'distanceM': json['distanceM'] == null ? undefined : json['distanceM'],
        'id': json['id'] == null ? undefined : json['id'],
        'label': json['label'] == null ? undefined : json['label'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lng': json['lng'] == null ? undefined : json['lng'],
    };
}

export function OutputGeoPlaceNearestToJSON(value?: OutputGeoPlaceNearest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'distanceM': value['distanceM'],
        'id': value['id'],
        'label': value['label'],
        'lat': value['lat'],
        'lng': value['lng'],
    };
}

